(function () {
    'use strict';

    angular
        .module('app')
        .controller('BadgesAddController', BadgesAddController);

    BadgesAddController.$inject = ['$stateParams','$scope', '$state', 'API', 'i18n', 'debug',];

    function BadgesAddController($stateParams, $scope, $state, API, i18n, debug) {
        $scope.$state = $state;
        var vm = this;
        vm.isAdding = false;
        vm.add = add;
        vm.subjects = [{ id: '' }];
        vm.addSubject = addSubject;
        vm.removeSubject = removeSubject;
        vm.badge = {};
        vm.gameTags = [
            {
                name: 'Loading...',
                label: 'Loading...',
                value: ''
            }
        ];
        vm.availableSubjects = [];

        vm.loadingState = {
            'gameTagsAreLoading': false,
        };

        activate();

        function activate() {
            loadGameTags();
            loadSubjects();
        }

        function add() {
            if (!vm.isAdding) {
                vm.isAdding = true;

                var subjectIds = [];
                angular.forEach(vm.subjects, function(subject){
                    if(parseInt(subject.id, 10) > 0) {
                        subjectIds.push(parseInt(subject.id, 10));
                    }
                });

                if(subjectIds.length){
                    vm.badge.subject_ids = subjectIds;
                }

                var newBadge = new API.Badge(vm.badge);

                var promise = newBadge.$save();

                promise.then(function (response) {
                    window.toast({ message: i18n.get('SAVED'), autoRemoveTime: 5000, type: 'success' });
                    $state.go('badges.edit', { id: response.id });
                }, function () {})
                .finally(function() {
                    vm.isAdding = false;
                });
            }
        }

        function loadGameTags() {
            vm.loadingState.gameTagsAreLoading = true;
            var promise = API.Game.get().$promise;

            promise.then(function(response) {
                if (response.items.length) {
                    vm.gameTags = [];
                    angular.forEach(response.items, function(game) {
                        vm.gameTags.push({
                            name: game.name,
                            label: game.name,
                            value: game.tag
                        });
                    });
                }
            }, function(response) {
                debug.log(response);
            })
            .finally(function() {
                vm.loadingState.gameTagsAreLoading = false;
            });
        }

        function loadSubjects() {
            API.Subject.search({ 'per-page': -1 }).$promise.then(function(response) {
                if(response.items && response.items.length){
                    vm.availableSubjects = response.items;
                }
            }, console.error);
        }

        function addSubject() {
            vm.subjects.push({ id: '' });
        }

        function removeSubject(index){
            vm.subjects.splice(index, 1);
        }
    }
})();